import * as React from 'react';

const AccessoriesCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AccessoriesCarousel-Chunk" */ './organisms/AccessoriesCarousel/AccessoriesCarousel'
    )
);
const Accordion = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Accordion-Chunk" */ './organisms/Accordion/Accordion'
    )
);
const AccordionItem = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AccordionItem-Chunk" */ './molecules/AccordionItem/AccordionItem'
    )
);
const AccountContent = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AccountContent-Chunk" */ './organisms/AccountContent/AccountContent'
    )
);
const AccountHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AccountHero-Chunk" */ './organisms/AccountHero/AccountHero'
    )
);
const AccountRegistration = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AccountRegistration-Chunk" */ './organisms/AccountRegistration/AccountRegistration'
    )
);
const AdyenConfirmation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdyenConfirmation-Chunk" */ './organisms/AdyenConfirmation/AdyenConfirmation'
    )
);
const AlternativeHeroBanner = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AlternativeHeroBanner-Chunk" */ './organisms/AlternativeHero/AlternativeHero'
    )
);
const AmbassadorCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AmbassadorCarousel-Chunk" */ './organisms/AmbassadorCarousel/AmbassadorCarousel'
    )
);
const AmbassadorQuotes = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AmbassadorQuotes-Chunk" */ './organisms/AmbassadorQuotes/AmbassadorQuotes'
    )
);
const AnchorNavigation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AnchorNavigation-Chunk" */ './organisms/AnchorNavigation/AnchorNavigation'
    )
);
const ArticleHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleHero-Chunk" */ './organisms/ArticleHero/ArticleHero'
    )
);
const ArticleLikes = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleLikes-Chunk" */ './organisms/ArticleLikes/ArticleLikes'
    )
);
const ArticleShare = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleShare-Chunk" */ './organisms/ArticleShare/ArticleShare'
    )
);
const ArticleTypeListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleTypeListing-Chunk" */ './organisms/ArticleTypeListing/ArticleTypeListing'
    )
);
const Author = React.lazy(
  () =>
    import(/* webpackChunkName: "Author-Chunk" */ './organisms/Author/Author')
);
const AuthorBiography = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AuthorBiography-Chunk" */ './organisms/AuthorBiography/AuthorBiography'
    )
);
const AuthorHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AuthorHero-Chunk" */ './organisms/AuthorHero/AuthorHero'
    )
);
const AuthorProfileListingsFeature = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AuthorProfileListingsFeature-Chunk" */ './organisms/AuthorProfileListingsFeature/AuthorProfileListingsFeature'
    )
);
const AuthorTypeListings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AuthorTypeListings-Chunk" */ './organisms/AuthorTypeListings/AuthorTypeListings'
    )
);
const AwardsCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AwardsCarousel-Chunk" */ './organisms/AwardsCarousel/AwardsCarousel'
    )
);
const BasicFooter = React.lazy(
  () =>
    import(
      /* webpackChunkName: "BasicFooter-Chunk" */ './organisms/BasicFooter/BasicFooter'
    )
);
const BasicHeader = React.lazy(
  () =>
    import(
      /* webpackChunkName: "BasicHeader-Chunk" */ './organisms/BasicHeader/BasicHeader'
    )
);
const Basket = React.lazy(
  () =>
    import(/* webpackChunkName: "Basket-Chunk" */ './organisms/Basket/Basket')
);
const Breadcrumb = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Breadcrumb-Chunk" */ './organisms/Breadcrumb/Breadcrumb'
    )
);
const CampaignHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CampaignHero-Chunk" */ './organisms/CampaignHero/CampaignHero'
    )
);
const CampaignIntroduction = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CampaignIntroduction-Chunk" */ './organisms/CampaignIntroduction/CampaignIntroduction'
    )
);
const CardCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CardCarousel-Chunk" */ './organisms/CardCarousel/CardCarousel'
    )
);
const CategoryContentCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CategoryContentCards-Chunk" */ './organisms/CategoryContentCards/CategoryContentCards'
    )
);
const Checkout = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Checkout-Chunk" */ './organisms/Checkout/Checkout'
    )
);
const CheckoutBasketNotifications = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CheckoutBasketNotifications-Chunk" */ './organisms/CheckoutBasketNotifications/CheckoutBasketNotifications'
    )
);
const CheckoutSignInOptions = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CheckoutSignInOptions-Chunk" */ './organisms/CheckoutSignInOptions/CheckoutSignInOptions'
    )
);
const ContactForm = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContactForm-Chunk" */ './organisms/ContactForm/ContactForm'
    )
);
const ContactUsBanner = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContactUsBanner-Chunk" */ './molecules/ContactUsBanner/ContactUsBanner'
    )
);
const ContentCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContentCards-Chunk" */ './organisms/ContentCards/ContentCards'
    )
);
const CountdownWithImage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CountdownWithImage-Chunk" */ './organisms/CountdownWithImage/CountdownWithImage'
    )
);
const CountryCheckerModal = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CountryCheckerModal-Chunk" */ './organisms/CountryCheckerModal/CountryCheckerModal'
    )
);
const CourseContentPlayback = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CourseContentPlayback-Chunk" */ './organisms/CourseContentPlayback/CourseContentPlayback'
    )
);
const CourseDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CourseDetails-Chunk" */ './organisms/CourseDetails/CourseDetails'
    )
);
const CourseGatedDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CourseGatedDetails-Chunk" */ './organisms/CourseDetailsGated/CourseDetailsGated'
    )
);
const CourseHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CourseHero-Chunk" */ './organisms/CourseHero/CourseHero'
    )
);
const CourseListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CourseListing-Chunk" */ './organisms/CourseListing/CourseListing'
    )
);
const CourseOverviewTabs = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CourseOverviewTabs-Chunk" */ './organisms/CourseOverviewTabs/CourseOverviewTabs'
    )
);
const CtaBanner = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CtaBanner-Chunk" */ './molecules/CtaBanner/CtaBanner'
    )
);
const CtaFeature = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CtaFeature-Chunk" */ './organisms/CtaFeature/CtaFeature'
    )
);
const CtaFeatureBuyNow = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CtaFeatureBuyNow-Chunk" */ './organisms/CtaFeatureBuyNow/CtaFeatureBuyNow'
    )
);
const CTAFeaturesCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CTAFeaturesCarousel-Chunk" */ './organisms/CTAFeaturesCarousel/CTAFeaturesCarousel'
    )
);
const CustomerQuotes = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CustomerQuotes-Chunk" */ './organisms/CustomerQuotes/CustomerQuotes'
    )
);
const EmbeddedVideo = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EmbeddedVideo-Chunk" */ './molecules/EmbeddedVideo/EmbeddedVideo'
    )
);
const ErrorBannerNotification = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ErrorBannerNotification-Chunk" */ './organisms/ErrorBannerNotification/ErrorBannerNotification'
    )
);
const ExpandingVideo = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExpandingVideo-Chunk" */ './organisms/ExpandingVideo/ExpandingVideo'
    )
);
const ExternalVideoPlaylist = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ExternalVideoPlaylist-Chunk" */ './organisms/ExternalVideoPlaylist/ExternalVideoPlaylist'
    )
);
const FeaturedContentCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeaturedContentCarousel-Chunk" */ './organisms/FeaturedContentCarousel/FeaturedContentCarousel'
    )
);
const FeaturedCourses = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeaturedCourses-Chunk" */ './organisms/FeaturedCourses/FeaturedCourses'
    )
);
const FeaturedProductsGrid = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeaturedProductsGrid-Chunk" */ './organisms/FeaturedProductsGrid/FeaturedProductsGrid'
    )
);
const ProductCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductCarousel-Chunk" */ './organisms/ProductCarousel/ProductCarousel'
    )
);
const FeaturedImageGallery = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeaturedImageGallery-Chunk" */ './organisms/FeaturedImageGallery/FeaturedImageGallery'
    )
);
const FeatureLeft = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureLeft-Chunk" */ './organisms/FeatureLeft/FeatureLeft'
    )
);
const FeatureLeftFullWidth = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureLeftFullWidth-Chunk" */ './organisms/FeatureLeftFullWidth/FeatureLeftFullWidth'
    )
);
const FeatureOverlap = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureOverlap-Chunk" */ './organisms/FeatureOverlap/FeatureOverlap'
    )
);
const FeatureRight = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureRight-Chunk" */ './organisms/FeatureRight/FeatureRight'
    )
);
const FeatureRightFullWidth = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FeatureRightFullWidth-Chunk" */ './organisms/FeatureRightFullWidth/FeatureRightFullWidth'
    )
);
const Footer = React.lazy(
  () =>
    import(/* webpackChunkName: "Footer-Chunk" */ './organisms/Footer/Footer')
);
const FPSShowcase = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FPSShowcase-Chunk" */ './organisms/FPSShowcase/FPSShowcase'
    )
);
const FullWidthImageFeature = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FullWidthImageFeature-Chunk" */ './organisms/FullWidthImageFeature/FullWidthImageFeature'
    )
);
const GeneralQuoteCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "GeneralQuoteCarousel-Chunk" */ './organisms/GeneralQuoteCarousel/GeneralQuoteCarousel'
    )
);
const GlobalSettings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "GlobalSettings-Chunk" */ './organisms/GlobalSettings/GlobalSettings'
    )
);
const Header = React.lazy(
  () =>
    import(/* webpackChunkName: "Header-Chunk" */ './organisms/Header/Header')
);
const ImageFullWidth = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImageFullWidth-Chunk" */ './organisms/ImageFullWidth/ImageFullWidth'
    )
);
const ImageCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImageCarousel-Chunk" */ './organisms/ImageCarousel/ImageCarousel'
    )
);
const ImageFeature = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImageFeature-Chunk" */ './organisms/ImageFeature/ImageFeature'
    )
);
const ImageGalleryBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImageGalleryBlock-Chunk" */ './organisms/ImageGalleryBlock/ImageGalleryBlock'
    )
);
const ImageWithProductFeature = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImageWithProductFeature-Chunk" */ './organisms/ImageWithProductFeature/ImageWithProductFeature'
    )
);
const ImmersiveVideo = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImmersiveVideo-Chunk" */ './organisms/ImmersiveVideo/ImmersiveVideo'
    )
);
const ImpactHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImpactHero-Chunk" */ './organisms/ImpactHero/ImpactHero'
    )
);
const InformativeHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "InformativeHero-Chunk" */ './organisms/InformativeHero/InformativeHero'
    )
);
const InlineVideo = React.lazy(
  () =>
    import(
      /* webpackChunkName: "InlineVideo-Chunk" */ './organisms/InlineVideo/InlineVideo'
    )
);
const InterestArticleFilter = React.lazy(
  () =>
    import(
      /* webpackChunkName: "InterestArticleFilter-Chunk" */ './organisms/InterestArticleFilter/InterestArticleFilter'
    )
);
const KeyholeVideo = React.lazy(
  () =>
    import(
      /* webpackChunkName: "KitBag-Chunk" */ './organisms/KeyholeVideo/KeyholeVideo'
    )
);
const KitBag = React.lazy(
  () =>
    import(/* webpackChunkName: "KitBag-Chunk" */ './organisms/KitBag/KitBag')
);
const KitCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "KitCarousel-Chunk" */ './organisms/KitCarousel/KitCarousel'
    )
);
const LensCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LensCard-Chunk" */ './molecules/LensCard/LensCard'
    )
);
const LensGlossary = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LensGlossary-Chunk" */ './organisms/LensGlossary/LensGlossary'
    )
);
const LightScrollAnimation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LightScrollAnimation-Chunk" */ './organisms/LightScrollAnimation/LightScrollAnimation'
    )
);
const LocationDiverter = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LocationDiverter-Chunk" */ './organisms/LocationDiverter/LocationDiverter'
    )
);
const LocationMap = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LocationMap-Chunk" */ './organisms/LocationMap/LocationMap'
    )
);
const MultiStepContentCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MultiStepContentCards-Chunk" */ './organisms/MultiStepContentCards/MultiStepContentCards'
    )
);
const NewsletterSignupBanner = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NewsletterSignupBanner-Chunk" */ './organisms/NewsletterSignupBanner/NewsletterSignupBanner'
    )
);
const NewsletterSignupForm = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NewsletterSignupForm-Chunk" */ './organisms/NewsletterSignupForm/NewsletterSignupForm'
    )
);
const NewsletterSignupPopup = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NewsletterSignupPopup-Chunk" */ './organisms/NewsletterSignupPopup/NewsletterSignupPopup'
    )
);
const NovunaConfirmation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NovunaConfirmation-Chunk" */ './organisms/NovunaConfirmation/NovunaConfirmation'
    )
);
const OffersPageText = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OffersPageText-Chunk" */ './organisms/OffersPageText/OffersPageText'
    )
);
const OnlineRetailers = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OnlineRetailers-Chunk" */ './organisms/OnlineRetailers/OnlineRetailers'
    )
);
const OrderConfirmation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OrderConfirmation-Chunk" */ './organisms/OrderConfirmation/OrderConfirmation'
    )
);
const OverviewTechSpecs = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OverviewTechSpecs-Chunk" */ './organisms/OverviewTechSpecs/OverviewTechSpecs'
    )
);
const PageBackgroundAnimator = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PageBackgroundAnimator-Chunk" */ './organisms/PageBackgroundAnimator/PageBackgroundAnimator'
    )
);
const ParallaxHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ParallaxHero-Chunk" */ './organisms/ParallaxHero/ParallaxHero'
    )
);
const PreReleaseCaptureImageHighlight = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PreReleaseCaptureImageHighlight-Chunk" */ './organisms/PreReleaseCaptureImageHighlight/PreReleaseCaptureImageHighlight'
    )
);
const ProductComparison = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductComparison-Chunk" */ './organisms/ProductComparison/ProductComparison'
    )
);
const ProductDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductDetails-Chunk" */ './organisms/ProductDetails/ProductDetails'
    )
);
const ProductEndorsers = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductEndorsers-Chunk" */ './organisms/ProductEndorsers/ProductEndorsers'
    )
);
const ProductFeatureHighlights = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductFeatureHighlights-Chunk" */ './organisms/ProductFeatureHighlights/ProductFeatureHighlights'
    )
);
const ProductFootnote = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductFootnote-Chunk" */ './organisms/ProductFootnote/ProductFootnote'
    )
);
const ProductHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductHero-Chunk" */ './organisms/ProductHero/ProductHero'
    )
);
const ProductImageGallery = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductImageGallery-Chunk" */ './organisms/ProductImageGallery/ProductImageGallery'
    )
);
const ProductListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductListing-Chunk" */ './organisms/ProductListing/ProductListing'
    )
);
const ProductNavigation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductNavigation-Chunk" */ './organisms/ProductNavigation/ProductNavigation'
    )
);
const ProductOffersListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductOffersListing-Chunk" */ './organisms/ProductOffersListing/ProductOffersListing'
    )
);
const ProductOverview = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductOverview-Chunk" */ './organisms/ProductOverview/ProductOverview'
    )
);
const QuickLinks = React.lazy(
  () =>
    import(
      /* webpackChunkName: "QuickLinks-Chunk" */ './organisms/QuickLinks/QuickLinks'
    )
);
const Quote = React.lazy(
  () => import(/* webpackChunkName: "Quote-Chunk" */ './molecules/Quote/Quote')
);
const RelatedArticles = React.lazy(
  () =>
    import(
      /* webpackChunkName: "RelatedArticles-Chunk" */ './organisms/RelatedArticles/RelatedArticles'
    )
);
const RelatedCourses = React.lazy(
  () =>
    import(
      /* webpackChunkName: "RelatedCourses-Chunk" */ './organisms/RelatedCourses/RelatedCourses'
    )
);
const RelatedLinks = React.lazy(
  () =>
    import(
      /* webpackChunkName: "RelatedLinks-Chunk" */ './organisms/RelatedLinks/RelatedLinks'
    )
);
const SearchBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SearchBlock-Chunk" */ './organisms/SearchBlock/SearchBlock'
    )
);
const SearchResults = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SearchResults-Chunk" */ './organisms/SearchResults/SearchResults'
    )
);
const SectionNavigation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SectionNavigation-Chunk" */ './organisms/SectionNavigation/SectionNavigation'
    )
);
const SimplifiedProductImageGallery = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SimplifiedProductImageGallery-Chunk" */ './organisms/SimplifiedProductImageGallery/SimplifiedProductImageGallery'
    )
);
const SiteNotifications = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SiteNotifications-Chunk" */ './organisms/SiteNotifications/SiteNotifications'
    )
);
const StoreLocator = React.lazy(
  () =>
    import(
      /* webpackChunkName: "StoreLocator-Chunk" */ './organisms/StoreLocator/StoreLocator'
    )
);
const SubheaderCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SubHeaderCard-Chunk" */ './molecules/SubheaderCard/SubheaderCard'
    )
);
const SubheaderCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SubHeaderCards-Chunk" */ './organisms/SubheaderCards/SubheaderCards'
    )
);
const TabbedFeature = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFeature-Chunk" */ './organisms/TabbedFeature/TabbedFeature'
    )
);
const TabbedFeatureCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFeatureCarousel-Chunk" */ './organisms/TabbedFeatureCarousel/TabbedFeatureCarousel'
    )
);
const TabbedFlipboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFlipboard-Chunk" */ './organisms/TabbedFlipboard/TabbedFlipboard'
    )
);
const TabbedFlipboardTab = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFlipboardTab-Chunk" */ './organisms/TabbedFlipboard/TabbedFlipboardTab'
    )
);
const TabbedFlipboardMediaCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFlipboardMediaCard-Chunk" */ './organisms/TabbedFlipboard/cardTypes/TabbedFlipboardMediaCard'
    )
);
const TabbedFlipboardSmallMediaCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFlipboardSmallMediaCard-Chunk" */ './organisms/TabbedFlipboard/cardTypes/TabbedFlipboardSmallMediaCard'
    )
);
const TabbedFlipboardTextCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFlipboardTextCard-Chunk" */ './organisms/TabbedFlipboard/cardTypes/TabbedFlipboardTextCard'
    )
);
const TabbedFlipboardSmallTextCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFlipboardSmallTextCard-Chunk" */ './organisms/TabbedFlipboard/cardTypes/TabbedFlipboardSmallTextCard'
    )
);
const TabbedFlipboardSplitCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedFlipboardSplitCard-Chunk" */ './organisms/TabbedFlipboard/cardTypes/TabbedFlipboardSplitCard'
    )
);

const TabbedMediaCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedMediaCarousel-Chunk" */ './organisms/TabbedMediaCarousel/TabbedMediaCarousel'
    )
);

const TabbedProductListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedProductListing-Chunk" */ './organisms/TabbedProductListing/TabbedProductListing'
    )
);

const TabbedProductsCrossSellList = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TabbedProductsCrossSellList-Chunk" */ './organisms/TabbedProductsCrossSellList/TabbedProductsCrossSellList'
    )
);

const TechHighlight = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TechHighlight-Chunk" */ './organisms/TechHighlight/TechHighlight'
    )
);
const TechnicalSpecification = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TechnicalSpecification-Chunk" */ './organisms/TechnicalSpecification/TechnicalSpecification'
    )
);
const TextAndLogo = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductIntroWithLogo-Chunk" */ './organisms/ProductIntroWithLogo/ProductIntroWithLogo'
    )
);
const TiledSpringboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TiledSpringboard-Chunk" */ './organisms/TiledSpringboard/TiledSpringboard'
    )
);
const USPsStrip = React.lazy(
  () =>
    import(
      /* webpackChunkName: "USPsStrip-Chunk" */ './organisms/USPsStrip/USPsStrip'
    )
);
const VideoWithAnimatedText = React.lazy(
  () =>
    import(
      /* webpackChunkName: "VideoWithAnimatedText-Chunk" */ './organisms/VideoWithAnimatedText/VideoWithAnimatedText'
    )
);
const VideoWithTextOver = React.lazy(
  () =>
    import(
      /* webpackChunkName: "VideoWithTextOver-Chunk" */ './organisms/VideoWithTextOver/VideoWithTextOver'
    )
);

export default {
  Accordion,
  AccordionItem,
  AccountContent,
  AccountHero,
  AccountRegistration,
  AlternativeHeroBanner,
  AmbassadorCarousel,
  AmbassadorQuotes,
  AnchorMenu: AnchorNavigation,
  ArticleHero,
  ArticleLikes,
  ArticleShare,
  ArticleTypeListing,
  Author,
  AuthorBiography,
  AuthorHero,
  AuthorProfileListingsFeature,
  AuthorTypeListings,
  AwardsCarousel,
  BasicFooter,
  BasicHeader,
  Basket,
  Breadcrumb,
  CTAFeature: CtaFeature,
  CTAFeatureBuyNow: CtaFeatureBuyNow,
  CTAFeaturesCarousel,
  CampaignHero,
  CampaignIntroduction,
  CardCarousel,
  CategoryContentCards,
  Checkout,
  CheckoutBasketNotifications,
  CheckoutSignInOptions,
  CompatibleProducts: ProductCarousel,
  ContactForm,
  ContactUsBanner,
  ContentCards,
  CountdownWithImage,
  CountryCheckerModal,
  CourseContentPlayback,
  CourseDetails,
  CourseGatedDetails,
  CourseHero,
  CourseListing,
  CourseOverviewTabs,
  CtaBanner,
  CustomerQuotes,
  EmbeddedVideo,
  ErrorBannerNotification,
  ExpandingVideo,
  ExternalVideoPlaylist,
  FPSShowcase,
  FeaturedImageGallery,
  FeatureLeft,
  FeatureLeftFullWidth,
  FeatureOverlap,
  FeatureRight,
  FeatureRightFullWidth,
  FeatureTextBlock: AwardsCarousel,
  FeaturedContentCarousel,
  FeaturedCourses,
  FeaturedProducts: ProductCarousel,
  FeaturedProductsGrid,
  Footer,
  FullWidthImageFeature,
  GeneralQuoteCarousel,
  GlobalSettings,
  Header,
  Image: ImageFullWidth,
  ImageCarousel,
  ImageFeature,
  ImageGalleryBlock,
  ImageWithProductFeature,
  ImmersiveVideo,
  ImpactHero,
  IncludedAccessories: AccessoriesCarousel,
  InformativeHero,
  InlineVideo,
  InterestArticleFilter,
  KeyholeVideo,
  KitBag,
  KitCarousel,
  LensCard,
  LensGlossary,
  LightScrollAnimation,
  LocationDiverter,
  LocationMap,
  MultiStepContentCards,
  NewsletterSignupBanner,
  NewsLetterSignup: NewsletterSignupForm,
  NewsletterSignupPopup,
  NovunaConfirmation,
  OffersPageText,
  OnlineRetailers,
  OptionalAccessories: AccessoriesCarousel,
  OrderConfirmation,
  OverviewTechSpecs,
  PageBackgroundAnimator,
  ParallaxHero,
  PaymentConfirmation: AdyenConfirmation,
  PreReleaseCaptureImageHighlight,
  ProductCarousel,
  ProductComparison,
  ProductDetails,
  ProductEndorsers,
  ProductFeatureHighlights,
  ProductFootnote,
  ProductHero,
  ProductImageGallery,
  ProductListing,
  ProductListingBlock: ProductListing,
  ProductOffersListingBlock: ProductOffersListing,
  ProductOverview,
  ProductNavigation,
  QuickLinks,
  Quote,
  RecentlyViewedProducts: ProductCarousel,
  RelatedArticles,
  RelatedAuthors: AuthorProfileListingsFeature,
  RelatedCourses,
  RelatedLinks,
  SearchBlock,
  SearchResults,
  SectionNavigation,
  SimplifiedProductImageGallery,
  SiteNotifications,
  StoreLocator,
  SubheaderCard,
  SubheaderCards,
  TabbedFeature,
  TabbedFeatureCarousel,
  TabbedFlipboard,
  FlipboardTab: TabbedFlipboardTab,
  FlipboardMediaCard: TabbedFlipboardMediaCard,
  FlipboardSmallMediaCard: TabbedFlipboardSmallMediaCard,
  FlipboardTextCard: TabbedFlipboardTextCard,
  FlipboardSmallTextCard: TabbedFlipboardSmallTextCard,
  FlipboardSplitCard: TabbedFlipboardSplitCard,
  TabbedMediaCarousel,
  TabbedProductListing,
  TabbedProductsCrossSellList,
  TechHighlight,
  TechnicalSpecification,
  TextAndLogo,
  TiledSpringboard,
  USPsStrip,
  VideoWithAnimatedText,
  VideoWithTextOver,
};
